import { apiService } from '../../shared/services/apiService';
import { ChallengePaymentResult, PaymentInfo } from '../interfaces/paymentResult';

export const paymentResultService = {
  async getPaymentDetails(paymentIntentId: string, connectedAccountId: string) {
    const params = { paymentIntentId, connectedAccountId };

    const response = await apiService.post<PaymentInfo>(
      '/api/sign-up/payment/details',
      params,
    );

    return response.data;
  },

  async getChallengePaymentDetails(
    participantId: number,
    paymentIntentId: string,
    connectedAccountId: string,
  ) {
    const params = { paymentIntentId, connectedAccountId };

    const response = await apiService.post<ChallengePaymentResult>(
      `/api/challenge/participant/${participantId}/subscribe/payment-result`,
      params,
    );

    return response.data;
  },

  async getChallengeFreePaymentDetails(participantId: number) {
    const response = await apiService.get<ChallengePaymentResult>(
      `/api/challenge/participant/${participantId}/free-subscribe/payment-result`,
    );

    return response.data;
  },
};
